import { forwardRef } from 'react'
import clsx from 'clsx'
import { Loader } from '../loader/Loader'
import styles from './NVButton.module.scss'

export const NVButton = forwardRef(
  (
    {
      id,
      variant = 'primary',
      text,
      height,
      width,
      disabled,
      classes = {},
      style = {},
      stretchContent = false,
      onClick,
      type = 'button',
      ariaLabel,
      icon,
      tabIndex,
      ariaHaspopup,
      ariaExpanded,
      onKeyDown,
      role,
      isLoading = false,
    }: any,
    ref: any,
  ) => {
    const buttonVariants = {
      primary: styles['btn--primary'],
      secondary: styles['btn--secondary'],
      cancel: styles['btn--cancel'],
      text: styles['btn--text'],
      iconOnly: styles['btn--icon-only'],
      redButton: styles['btn--red'],
      redOutlined: styles['btn--red-outlined'],
      greenButton: styles['btn--green'],
      greenOutlined: styles['btn--green-outlined'],
    }

    return isLoading ? (
      <Loader />
    ) : (
      <button
        id={id}
        ref={ref}
        type={type}
        style={{ height, width, ...style.container }}
        className={clsx(styles['btn'], buttonVariants[variant], classes.container, {
          [styles['btn--disabled']]: disabled || isLoading,
        })}
        disabled={disabled || isLoading}
        onClick={onClick}
        onKeyDown={onKeyDown}
        aria-label={ariaLabel || text}
        role={role || (variant === 'text' ? 'link' : 'button')}
        tabIndex={tabIndex}
        aria-haspopup={ariaHaspopup}
        aria-expanded={ariaExpanded}
      >
        <div
          className={clsx(styles['btn__content'], classes.content, {
            [styles['btn__center-text']]: !stretchContent,
          })}
          style={{ ...style.content }}
        >
          {icon && <span className={styles['btn__icon']}>{icon}</span>}
          {text && <div>{text}</div>}
          {variant === 'iconOnly' && ariaLabel && !text && <span className={styles['icon-only-label']}>{ariaLabel}</span>}
        </div>
      </button>
    )
  },
)

NVButton.displayName = 'NVButton'
